import {ReactElement} from 'react'

/** Port of webapp/src/components/loadingIndicator/loadingIndicator.tsx. */
export default function Loading({text = '加载中'}: {text?: string}): ReactElement {
    return (
        <div className='flex h-full w-full items-center justify-center' role='status' aria-live='polite'>
            <div className='flex flex-col items-center gap-2 opacity-70'>
                <svg
                    className='animate-spin'
                    width='28'
                    height='28'
                    viewBox='0 0 24 24'
                    fill='none'
                    aria-hidden={true}
                >
                    <circle cx='12' cy='12' r='9' stroke='currentColor' strokeOpacity='.2' strokeWidth='2'/>
                    <path d='M21 12a9 9 0 00-9-9' stroke='currentColor' strokeWidth='2' strokeLinecap='round'/>
                </svg>
                <span className='text-xs'>{text}</span>
            </div>
        </div>
    )
}
